// extracted by mini-css-extract-plugin
export default {"button":"GLA1t","tooltip":"qsOm1","tooltipInner":"lz52A"};